import mixpanel from "mixpanel-browser";
import dayjs from "./dayjs";

type Properties = Record<string, unknown>;

/**
 * 믹스패널에 이벤트를 전달합니다.
 */
export const trackEvent = (eventName: string, properties: Properties) => {
  mixpanel.track(eventName, properties);
};

/**
 * 믹스패널에 전역 속성값을 등록합니다.
 */
export const registerGlobalProperties = (properties: Properties) => {
  mixpanel.register(properties);
};

/**
 * 로그인 이후, 믹스패널에 사용자를 등록합니다.
 */
export const identifyUser = (userId: string, properties: Properties) => {
  mixpanel.identify(userId);
  mixpanel.people.set({
    ...properties,
    name: userId,
    LoginTime: dayjs().format(),
  });
};

/**
 * 로그아웃 이후, identifyUser을 이용한 유저 등록을 취소 시킵니다.
 */
export const resetUser = () => {
  mixpanel.reset();
};

/**
 * 믹스패널 초기화
 */
export const initMixpanel = () => {
  const isProd = import.meta.env.VITE_ENV === "master";

  mixpanel.init(
    isProd
      ? "416c9a2e84187915049d935ac2e33bca" // for prod
      : "74d045eb25b8cc40d335a550e9f482ed", // for dev, qa
    {
      persistence: "localStorage",
      track_pageview: true,
    }
  );

  // default global properties
  registerGlobalProperties({
    ENV: import.meta.env.VITE_ENV,
    Version: __APP_VERSION__,
  });
};
